import React from 'react';
import { HStack, Switch, SwitchProps, FormLabel } from '@wegroup/design-system';

interface Props {
  offLabel: string;
  onLabel: string;
}

const LabeledSwitch: React.FC<Props & SwitchProps> = ({
  offLabel,
  onLabel,
  ...switchProps
}) => {
  return (
    <HStack spacing="4">
      <FormLabel m="0" htmlFor={switchProps?.name}>
        {offLabel}
      </FormLabel>
      <Switch {...switchProps} />
      <FormLabel m="0" htmlFor={switchProps?.name}>
        {onLabel}
      </FormLabel>
    </HStack>
  );
};

export default LabeledSwitch;
